<template>
  <div
    class="base-aspect-ratio"
    :class="{ 'base-aspect-ratio--with-full-height': props.withFullHeight }"
    :style="aspectStyle"
  >
    <div class="base-aspect-ratio__content">
      <slot />
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'

const props = defineProps<{
  width: number
  height: number
  withFullHeight?: boolean
}>()

const aspectStyle = computed(() => ({
  '--aspect-ratio': `${(props.height / props.width) * 100}%`,
}))
</script>

<style lang="scss" scoped>
.base-aspect-ratio {
  position: relative;
  height: 100%;

  &::before {
    display: block;
    content: "";
    width: 100%;
    padding-top: var(--aspect-ratio);
  }

  &__content {
    position: absolute;
    inset: 0;
  }

  &--with-full-height {
    height: 100%;

    &::before {
      display: none;
    }
  }
}
</style>
